module.exports = __webpack_public_path__ + "static/4BHK-06-Bedroom-02-76f97713d9b758c2f4c97294cab65912.jpg";